<template>
  <div class="modal fade" :ref="`modal-send-test-email`">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ $t("common.sendTest") }}</h4>
        </div>

        <div class="modal-body">
          <div class="form-group">
              <label for="title">{{$t('common.email')}}</label>
              <input
                class="form-control"
                v-model="emailList"
                type="text"
                id="emailList"
                :placeholder="$t('common.email')"
              />
            </div>
        </div>

        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.close") }}
          </button>
          <button
            type="button"
            :disabled="!isValidEmail(emailList)"
            class="btn btn-primary"
            @click="onSendTestEmail"
          >
          {{ $t("common.send") }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';

export default {
  components: {
    loading: Loading
  },
  props: {},
  data() {
    return {
      isLoading: false,
      smtpKey: null,
      emailList: null
    };
  },
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR'
    ])
  },
  methods: {
    onShowModal: function(smtpKey) {
      this.smtpKey = smtpKey
      $(this.$refs[`modal-send-test-email`]).modal("show");
    },
    isValidEmail: function (email) {
      if (!utils.isEmptyString(email) && utils.validateEmailAddress(email)) {
        return true
      }
      return false
    },
    onSendTestEmail: function() {
      let data = {
        toEmails: this.emailList,
        smtpServiceKey: this.smtpKey
      }
      this.isLoading = true
      this.SEND_EMAIL_FOR_TESTINNG(data).then(
        function() {
          this.isLoading = false
          this.SUCCESS_TOAST();
          $(this.$refs[`modal-send-email-and-notification`]).modal("hide");
          // this.$emit('onConfirm', true)
        }.bind(this)
      ).catch(
        function(error) {
          this.isLoading = false
          this.ON_SHOW_TOAST({
            message: error.response.data.message,
            styleType: "danger"
          })
          // this.ERROR_TOAST();
        }.bind(this)
      );
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    ...mapActions([
      'ON_SHOW_TOAST',
      'SUCCESS_TOAST',
      'ERROR_TOAST',
      'SEND_EMAIL_FOR_TESTINNG'
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Project/SendTestEmailModal.vue